export const translation = {
  // Navbar
  nav_spreadsheet: 'Tableur',
  nav_categories: 'Catégories',
  nav_guides: 'Guides',
  nav_shipping: 'Livraison',
  nav_qc: 'CQ',
  nav_reviews: 'Avis',
  nav_language: 'Langue',
  nav_cta: 'Visiter le Site Principal',
  nav_home: 'Accueil',
  nav_shopping_guide: 'Guide d\'Achat',

  // Hero
  hero_eyebrow: 'HUB DE RESSOURCES ALLCHINABUY SPREADSHEET',
  hero_title: 'AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs et Guides d\'Achat',
  hero_desc: 'Vous cherchez un tableur AllChinaBuy ? Explorez des ressources produits organisées, des informations sur les vendeurs, des guides de contrôle qualité, des conseils de livraison et des guides pratiques — tout regroupé dans un hub facile à utiliser.',
  hero_cta_primary: 'Explorer AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Parcourir les Guides d\'Achat',
  hero_trust: 'Ressource indépendante · Mise à jour régulièrement · Multilingue',
  hero_search_placeholder: 'Rechercher un tableur, produits, vendeurs ou guides AllChinaBuy...',

  // Trust Bar
  trust_spreadsheet: 'Ressources Spreadsheet',
  trust_spreadsheet_desc: 'Informations produits et vendeurs organisées.',
  trust_guides: 'Guides d\'Achat',
  trust_guides_desc: 'Guides pratiques pour débutants et utilisateurs expérimentés.',
  trust_qc: 'CQ & Sécurité',
  trust_qc_desc: 'Comprendre les contrôles qualité et les risques courants.',
  trust_shipping: 'Ressources Livraison',
  trust_shipping_desc: 'Apprenez les méthodes, coûts et considérations de livraison.',

  // What Is Section
  what_is_title: 'Qu\'est-ce qu\'un AllChinaBuy Spreadsheet ?',
  what_is_desc: 'Un AllChinaBuy Spreadsheet est un moyen pratique d\'organiser les informations produits, vendeurs et achats en un seul endroit. Notre hub de ressources vous aide à découvrir des ressources utiles, comprendre les catégories, comparer les options et apprendre le processus d\'achat.',
  what_is_cta: 'Explorer le Hub Spreadsheet →',

  // Categories Section
  categories_title: 'Parcourir les Catégories Populaires',
  categories_cta: 'Explorer Toutes les Catégories →',

  // Popular Searches
  popular_title: 'Recherches AllChinaBuy Populaires',
  popular_spreadsheet: 'AllChinaBuy Spreadsheet',
  popular_review: 'Avis AllChinaBuy',
  popular_shipping: 'Coût de Livraison AllChinaBuy',
  popular_coupon: 'Coupon AllChinaBuy',
  popular_discount: 'Code Promo AllChinaBuy',
  popular_warehouse: 'Entrepôt AllChinaBuy',
  popular_legit: 'AllChinaBuy Légitime',
  popular_qc: 'CQ AllChinaBuy',

  // Buying Guides
  guides_title: 'Guides d\'Achat AllChinaBuy',
  guides_desc: 'Apprenez à trouver des produits, évaluer les vendeurs, comprendre les informations CQ, estimer les coûts de livraison et éviter les erreurs courantes avec nos guides pratiques.',
  guides_cta: 'Voir Tous les Guides →',
  pillar_title: 'Articles Piliers AllChinaBuy',
  pillar_desc: 'Des guides originaux détaillés couvrant les tableurs, avis, livraison, entrepôt, CQ, vendeurs et comparaisons pour mieux acheter.',
  guide_1_title: 'Guide Complet du Spreadsheet',
  guide_1_desc: 'Maîtrisez le tableur AllChinaBuy avec notre guide complet.',
  guide_2_title: 'Calculateur de Coût de Livraison',
  guide_2_desc: 'Estimez les coûts de livraison avant d\'acheter avec notre détail.',
  guide_3_title: 'Liste de Contrôle Photos CQ',
  guide_3_desc: 'Apprenez ce qu\'il faut chercher dans les photos de contrôle qualité.',
  guide_4_title: 'Guide de Vérification Vendeurs',
  guide_4_desc: 'Comment identifier les vendeurs fiables et éviter les arnaques.',
  guide_5_title: 'Processus Entrepôt Expliqué',
  guide_5_desc: 'Comprendre comment l\'entrepôt AllChinaBuy gère vos articles.',
  guide_6_title: 'Stratégie d\'Achat Débutant',
  guide_6_desc: 'Conseils essentiels pour les premiers acheteurs sur AllChinaBuy.',

  // Comparison
  comparison_title: 'AllChinaBuy Comparé aux Autres Plateformes',
  comparison_cta: 'Voir Toutes les Comparaisons →',
  vs_superbuy: 'AllChinaBuy vs Superbuy',
  vs_cssbuy: 'AllChinaBuy vs CSSBuy',
  vs_sugargoo: 'AllChinaBuy vs Sugargoo',
  vs_kakobuy: 'AllChinaBuy vs Kakobuy',

  // Safety Section
  safety_title: 'Centre de Sécurité AllChinaBuy',
  safety_desc: 'Avant d\'acheter, apprenez à évaluer les vendeurs, protéger votre compte, reconnaître les liens suspects, comprendre les risques de paiement et prendre des décisions éclairées.',
  safety_cta: 'Visiter le Centre de Sécurité →',

  // Review Section
  review_title: 'AllChinaBuy est-il Légitime ?',
  review_desc: 'Vous vous demandez si AllChinaBuy est légitime, comment fonctionne l\'entrepôt ou à quoi vous attendre pour la livraison ? Nos guides indépendants expliquent les considérations clés.',
  review_cta: 'Lire l\'Avis AllChinaBuy →',

  // FAQ
  faq_title: 'FAQ AllChinaBuy Spreadsheet',
  faq_q1: 'Qu\'est-ce qu\'un AllChinaBuy spreadsheet ?',
  faq_a1: 'Un AllChinaBuy spreadsheet est une collection organisée de liens produits, d\'informations vendeurs et de ressources d\'achat pour une référence facile.',
  faq_q2: 'Comment utiliser un AllChinaBuy spreadsheet ?',
  faq_a2: 'Parcourez simplement les catégories, cliquez sur les liens produits pour voir les détails, et suivez les guides d\'achat pour effectuer votre achat en toute sécurité.',
  faq_q3: 'AllChinaBuy est-il légitime ?',
  faq_a3: 'AllChinaBuy est une plateforme d\'agent d\'achat connue. Comme tout service en ligne, il est important de comprendre le processus et de suivre les lignes de sécurité.',
  faq_q4: 'AllChinaBuy est-il sûr ?',
  faq_a4: 'La sécurité dépend des bonnes pratiques : vérifiez les vendeurs, utilisez les photos CQ, comprenez les coûts de livraison et lisez nos guides de sécurité.',
  faq_q5: 'Combien coûte la livraison AllChinaBuy ?',
  faq_a5: 'Les coûts de livraison varient selon la destination, le poids et la méthode. Utilisez notre guide pour estimer les coûts avant de commander.',
  faq_q6: 'AllChinaBuy a-t-il un entrepôt ?',
  faq_a6: 'Oui, AllChinaBuy gère des entrepôts où les articles sont stockés, inspectés et consolidés avant l\'expédition internationale.',
  faq_q7: 'AllChinaBuy propose-t-il des coupons ou codes promo ?',
  faq_a7: 'Des codes de réduction peuvent être disponibles périodiquement. Consultez notre guide des coupons pour les offres actuelles.',
  faq_q8: 'Comment vérifier la qualité des produits ?',
  faq_a8: 'Demandez toujours des photos CQ avant l\'expédition. Notre guide CQ explique exactement ce qu\'il faut rechercher.',

  // Final CTA
  final_cta_title: 'Prêt à Explorer l\'AllChinaBuy Spreadsheet ?',
  final_cta_desc: 'Commencez avec le hub de tableurs, explorez les produits populaires, comparez les options et apprenez le processus d\'achat avec nos derniers guides.',
  final_cta_primary: 'Explorer AllChinaBuy Spreadsheet',
  final_cta_secondary: 'Visiter le Site Principal',
  final_cta_buy_now: 'Acheter Maintenant',

  // Footer
  footer_disclaimer: 'Ce site est une ressource d\'information indépendante. Ce n\'est pas le site officiel AllChinaBuy sauf mention explicite. Les informations peuvent changer, veuillez vérifier avant d\'acheter.',
  footer_copyright: '© 2026 allchinabuyspread.cc — Tous droits réservés.',
  footer_links: 'Liens Rapides',
  footer_resources: 'Ressources',
  footer_legal: 'Mentions Légales',
  footer_privacy: 'Politique de Confidentialité',
  footer_terms: 'Conditions d\'Utilisation',
  footer_disclaimer_link: 'Avertissement',
  footer_contact: 'Contact',
  footer_about: 'À Propos',

  // Common
  allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  read_more: 'Lire la Suite',
  learn_more: 'En Savoir Plus',
  search: 'Rechercher',
  category: 'Catégorie',
  product: 'Produit',
  seller: 'Vendeur',
  price: 'Prix',
  last_updated: 'Dernière Mise à Jour',

  // Dropdown categories
  cat_shoes: 'Chaussures',
  cat_hoodies: 'Sweats / Pulls',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Vestes',
  cat_pants: 'Pantalons / Shorts',
  cat_headwear: 'Couvre-Chefs',
  cat_sets: 'Ensembles',
  cat_underwear: 'Sous-Vêtements',
  cat_jersey: 'Maillots',
  cat_accessories: 'Accessoires',
  cat_bags: 'Sacs',
  cat_belts: 'Ceintures',
  cat_perfumes: 'Parfums',
  cat_other: 'Autres Articles',
};